import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { activeSaarthiFetcher } from '../../fetchers/ask-saarthi';

type Props = {
  data: ActiveSaarthi[];
  isLoading: boolean;
  isFetching: boolean;
  error: any;
  refetch: any;
};
const useActiveSaarthi = ({
  className,
  exam,
  saarthi_id,
  enabled,
  premium,
}: {
  className?: string;
  exam?: string;
  saarthi_id: string;
  enabled?: boolean;
  premium?: boolean;
}): Props => {
  const { data, error, isLoading, isFetching, refetch } = useQuery(
    ['active-saarthi-fetcher', { saarthi_id, premium }],
    activeSaarthiFetcher,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: !!enabled,
    },
  );
  const ses: ActiveSaarthi[] = [];
  const returnedData = useMemo(() => {
    if (Array.isArray(data?.data)) {
      data?.data.forEach((item: any) => {
        ses.push(new ActiveSaarthi(item));
      });
    }
    return ses;
  }, [data]);
  return {
    data: returnedData,
    isLoading,
    error,
    isFetching,
    refetch,
  };
};
export class ActiveSaarthiRoot {
  success: boolean;
  data: ActiveSaarthi[];
  constructor(item: any) {
    item = item || {};
    this.success = item.success || false;
    if (item?.data) {
      this.data = item.data.map((res: any) => new ActiveSaarthi(res));
    } else {
      this.data = [];
    }
  }
}

export class ActiveSaarthi {
  _id: string;
  expiry_date: string;
  saarthi_id: SaarthiId;
  saarthi_plan_id: SaarthiPlanId;
  constructor(item: any) {
    item = item || {};
    this._id = item._id || '';
    this.expiry_date = item.expiry_date || '';
    this.saarthi_id = new SaarthiId(item.saarthi_id);
    this.saarthi_plan_id = new SaarthiPlanId(item.saarthi_plan_id);
  }
}

export class SaarthiId {
  _id: string;
  classes: string[];
  exams: string[];
  saarthi_slot: SaarthiSlot;
  constructor(item: any) {
    item = item || {};
    this._id = item._id || '';
    this.classes = item.classes || [];
    this.exams = item.exams || [];
    this.saarthi_slot = new SaarthiSlot(item.saarthi_slot);
  }
}

export class SaarthiSlot {
  start_time: string;
  end_time: string;
  constructor(data: any) {
    data = data || {};
    this.start_time = data.start_time || '';
    this.end_time = data.end_time || '';
  }
}

export class SaarthiPlanId {
  _id: string;
  duration: number;
  title: string;
  description: string;
  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.duration = data.duration || '';
    this.title = data.type || '';
    this.description = data.description || '';
  }
}

export default useActiveSaarthi;
